export default [
    {
        text: 'Получать КП',
        img: 'cp'
    },
    {
        text: 'Проходить демоны',
        img: 'demons'
    },
    {
        text: 'Фармить звёзды',
        img: 'stars'
    }
];